import { useMemo } from 'react'
import './github.css'
import GitHubCalendar from "react-github-calendar";
import { motion } from 'framer-motion';
import { useInView } from "react-intersection-observer";
function Github() {
  const [ref, inView] = useInView({
    triggerOnce: true,
  });
  const colourTheme = useMemo(() => ({
    background: "transparent",
    text: "#ffffff",
    level4: "#125425",
    level3: "#228f41",
    level2: "#31a851",
    level1: "#66cc78",
    level0: "#5b6775"
  }), []);
  return (
    <section className='github'>
      <motion.h5 whileInView={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: -50 }}
      transition={{
        duration:1.25,type: "spring",
      }}>GitHub</motion.h5>
      <motion.h2 whileInView={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: -50 }}
      transition={{
        duration:1.25,type: "spring",delay:0.3
      }}>My GitHub stats</motion.h2>
        <div>
        <div className=" container github_stats" ref={ref}>
            <motion.img initial={{ opacity: 0}}
            animate={inView ? { opacity: 1}:{ opacity: 0}}
      transition={{
        delay:1*0.5,type: "spring",ease: "easeOut",duration:0.75
      }} src="https://github-readme-stats.vercel.app/api?username=Dhanush-Saji&show_icons=true&locale=en&count_private=true&hide=contribs&theme=vue-dark" />
            <motion.img initial={{ opacity: 0}}
            animate={inView ? { opacity: 1}:{ opacity: 0}}
      transition={{
        delay:2*0.5,type: "spring",ease: "easeOut",duration:0.75
      }} src="https://github-readme-stats.vercel.app/api/top-langs/?username=Dhanush-Saji&border_radius=4.6&hide_border=true&layout=compact&show_icons=true&theme=vue-dark" />
        </div>
        <div className="container github_calendar">
        <h2>My GitHub calendar</h2>
        <GitHubCalendar style={{marginBottom:'1rem'}} username="Dhanush-Saji" blockSize={15} hideTotalCount={true} blockMargin={8} theme={colourTheme} fontSize={16} />
        </div>
        </div>
    </section>
  )
}

export default Github